import logoImg from "@/assets/logo.svg";

export default function Logo({ onClick }: { onClick?(): void }) {
  return (
    <div onClick={onClick} id="logo" className="flex-1 grow cursor-pointer">
      <img src={logoImg} alt="Takyon logo" />
    </div>
  );
}
